var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-session-3"},[_c('div',{staticClass:"bg-image"})])
}]

export { render, staticRenderFns }